import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import currencyFormat from 'functions/currencyFormat'

import QuoteWrapper from 'agency/digital_renderer/components/QuoteWrapper'

import ContentHolder from '../../../ui/ContentHolder'
import QuoteSection from './QuoteSection'
import styles from './styles.scss'

const CampaignQuote = (props) => {
  const { campaignQuote } = props

  return (
    <QuoteWrapper
      campaignQuote={campaignQuote}
      render={({ quoteSections }) => (
        <div className={styles.root}>
          <ContentHolder>
            {quoteSections.map(section => <QuoteSection key={section.id} campaignQuoteSection={section} />)}

            <div className={styles.footer}>
              {campaignQuote.links && (
                <a href={campaignQuote.links.pdf} className={styles.button}>
                  <FontAwesomeIcon icon={faDownload} className={styles.icon} /> Download Quote
                </a>
              )}

              <div className={styles.right}>
                <span className={styles.total}>{currencyFormat(campaignQuote.total)}</span>
              </div>
            </div>
          </ContentHolder>
        </div>
      )}
    />
  )
}

CampaignQuote.propTypes = {
  campaignQuote: PropTypes.object.isRequired,
}

export default CampaignQuote
